import * as Ease from './Ease';

/**
 * Плавная прокрутка содержимого элемента до указанной позиции.
 * 
 * @param {HTMLElement|Window} element Элемент
 * @param {number} to Позиция прокрутки, в пикселах
 * @param {number} duration Длительность анимации, мс
 * @param {boolean} [horizontal=false] Горизонтальная прокрутка?
 * @param {Ease.EasingFunction} [ease=Ease.quadOut] Функция изменения по времени
 */
function scrollElementTo( element: HTMLElement|Window, to: number, duration: number,
	horizontal: boolean = false, ease: Ease.EasingFunction = Ease.quadInOut ): void
{
	if (
		( duration <= 0 )
		|| !element
	)
	{
		return;
	}
	
	let startScroll: number;
	let setScroll: ( position: number ) => void;
	
	if ( element instanceof Window )
	{
		if ( horizontal )
		{
			startScroll = element.pageXOffset;
			setScroll = ( position: number ) =>
				element.scrollTo( position, element.pageYOffset );
		}
		else
		{
			startScroll = element.pageYOffset;
			setScroll = ( position: number ) =>
				element.scrollTo( element.pageXOffset, position );
		}
	}
	else if ( element instanceof HTMLElement )
	{
		if ( horizontal )
		{
			startScroll = element.scrollLeft;
			setScroll = ( position: number ) =>
				element.scrollLeft = position;
		}
		else
		{
			startScroll = element.scrollTop;
			setScroll = ( position: number ) =>
				element.scrollTop = position;
		}
	}
	
	const distance: number = to - startScroll;
	const startTime: number = Date.now();
	
	const tick = () =>
	{
		const time: number = (Date.now() - startTime) / duration;
		
		if ( time >= 1 )
		{
			setScroll( to );
			return;
		}
		
		setScroll( startScroll + distance * ease( time ) | 0 );
		window.requestAnimationFrame( tick );
	};
	
	tick();
}

export {scrollElementTo as default};
